<script>
import fieldMixin from '@maison/mixins/fieldMixin';
import { useField } from '@phoenix/composables/field';
import { defineAsyncComponent } from 'vue';

const RadioField = defineAsyncComponent(() => import('@maison/components/form/fields/RadioField.vue'));
const RadioProductField = defineAsyncComponent(() => import('@maison/components/form/fields/RadioProductField.vue'));
const RadioRichField = defineAsyncComponent(() => import('@maison/components/form/fields/RadioRichField.vue'));

export default {
  components: {
    RadioField,
    RadioProductField,
  },

  mixins: [fieldMixin],

  props: {
    type: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    radioComponent() {
      switch (this.type) {
        case 'product':
          return RadioProductField;
        case 'rich':
          return RadioRichField;
        default:
          return RadioField;
      }
    },
  },

  methods: {
    getOptionAttrs(option) {
      return {
        name: this.field.name,
        required: this.field.required,
        scope: this.field.scope,
        ...option,
      };
    },
  },
};
</script>

<template>
  <component
    :is="radioComponent"
    v-for="option in field.options"
    :key="`${field.id}-${option.id}`"
    v-model="value"
    :parent-id="field.id"
    :attrs="getOptionAttrs(option)"
    :should-validate="false"
  />
</template>
